const SESSION_KEY = 'cenva_intel_session_token'
const DEFAULT_WATCHLIST_KEY = 'cenva_intel_default_watchlist_id'
const ACTIVE_ORG_KEY = 'cenva_intel_active_org_id'
const ORG_SCOPED_KEY_PREFIX = 'cenva_intel_orgscope:'

export const SESSION_EXPIRED_EVENT = 'cenva_intel_session_expired'

export function setSessionToken(token: string) {
  localStorage.setItem(SESSION_KEY, token)
}

export function getSessionToken(): string | null {
  return localStorage.getItem(SESSION_KEY)
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY)
  localStorage.removeItem(DEFAULT_WATCHLIST_KEY)
  clearOrgScopedStorage()
  setActiveOrgId(null)
}

export function expireSession(reason = 'expired') {
  clearSession()
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, { detail: { reason } }))
}

export function setDefaultWatchlistId(watchlistId: string) {
  localStorage.setItem(DEFAULT_WATCHLIST_KEY, watchlistId)
}

export function getDefaultWatchlistId(): string | null {
  return localStorage.getItem(DEFAULT_WATCHLIST_KEY)
}

export function getActiveOrgId(): string | null {
  return localStorage.getItem(ACTIVE_ORG_KEY)
}

export function setActiveOrgId(orgId: string | null) {
  if (!orgId) {
    localStorage.removeItem(ACTIVE_ORG_KEY)
    return
  }
  localStorage.setItem(ACTIVE_ORG_KEY, orgId)
}

/**
 * Build an org-scoped localStorage key so UI state that belongs to one
 * org (e.g. the ask queue) doesn't leak across orgs when a staff user
 * uses the org switcher.
 */
export function orgScopedKey(baseKey: string, orgId: string | null = getActiveOrgId()): string {
  const oid = (orgId || '').trim() || '_anon'
  return `${ORG_SCOPED_KEY_PREFIX}${oid}:${baseKey}`
}

/** Drop every org-scoped localStorage entry. Called on logout / org switch. */
export function clearOrgScopedStorage() {
  try {
    const toRemove: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && k.startsWith(ORG_SCOPED_KEY_PREFIX)) toRemove.push(k)
    }
    toRemove.forEach((k) => localStorage.removeItem(k))
  } catch { /* ignore quota / security errors */ }
}
